module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n    " + _vm._s(tag) + "\n  ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aafa836"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Entities/Selects/TagSelect.vue
// module id = 714
// module chunks = 1